import React from 'react';
import { SelectedFilters, MultiDropdownList } from '@appbaseio/reactivesearch';
import { css } from 'emotion';

const filterContainer = css`
	display: flex;
	flex-direction: column;
	width: 100%;
	position: sticky;
	top: 70px;
	background: white;
	justify-content: space-evenly;

	.dropdownContainer {
		display: flex;
		.dropdown {
			width: 50%;
			button {
				border: 0;
				background: #f5f5f5;
				border: 1px solid #d9d9d9;
				border-radius: 2px;
			}
		}
	}
`;

const Filters = () => (
	<div className={filterContainer}>
		<div className="dropdownContainer">
			<MultiDropdownList
				componentId="genres"
				className="dropdown"
				dataField="genres.keyword"
				placeholder="Select Genre"
			/>
			<MultiDropdownList
				componentId="tagline"
				className="dropdown"
				dataField="tagline.keyword"
				placeholder="Choose Tagline"
			/>
		</div>
		<SelectedFilters />
	</div>
);

export default Filters;
